

import React from 'react';
import { Card, Radio } from 'antd';
import { icons } from '../../../assets/iconsPath';

const FlightRoundTripFareCard = ({ data, selectedValue, onChange, selectedCard }) => {

    return (
        <Card
            style={{
                marginBottom: '20px',
                borderColor: selectedCard === data?.id ? 'blue' : '#d9d9d9',
                borderWidth: '2px',
                borderStyle: 'solid',
                cursor: "pointer"
            }}
            onClick={onChange}
            styles={{ body: { padding: '12px' } }}
            className='mb-2'
        >
            <Radio
                checked={selectedValue}
                onChange={onChange}
                className='RoundFare mb-3'
            >
                <div className='lh-sm d-flex justify-content-between'>
                    <p className="fare-type lh-sm text-primary"><small>{data?.fareIdentifier}</small></p>
                    <p className="text-dark lh-sm fw-bold">₹{data?.totalFare?.toLocaleString()}</p>
                </div>
            </Radio>

            <div className="fare-card-body">
                {/* <div className="fare-details">
                    <div className="fare-row mb-1">
                        <span className="fare-label lh-sm">Cabin Class:</span>
                        <span className="fare-value lh-sm">{data?.cabinClass}</span>
                    </div>
                    <div className="fare-row mb-1">
                        <span className="fare-label lh-sm">Base Fare:</span>
                        <span className="fare-value lh-sm">{data?.baseFare}</span>
                    </div>
                    <div className="fare-row mb-1">
                        <span className="fare-label lh-sm">Tax Fare:</span>
                        <span className="fare-value lh-sm">{data?.taxFare}</span>
                    </div>
                    <div className="fare-row mb-1">
                        <span className="fare-label lh-sm">Check-in baggage:</span>
                        <span className="fare-value lh-sm">{data?.baggage}</span>
                    </div>
                    <div className="fare-row mb-1">
                        <span className="fare-label lh-sm">Cabin baggage:</span>
                        <span className="fare-value lh-sm">{data.cabinBaggage}</span>
                    </div>

                    {data?.meal && (
                        <div className="fare-row">
                            <span className="fare-label lh-sm">Meal :</span>
                            <span className="fare-value lh-sm">{data?.meal}</span>
                        </div>
                    )}

                    {data?.refund_type && (
                        <div className="fare-row">
                            <span className="fare-label lh-sm">Refund :</span>
                            <span className="fare-value lh-sm">{data?.refund_type}</span>
                        </div>
                    )}

                </div> */}
                <div className="fare-details">
                    <div className="mb-3">
                        <h4 className='d-flex align-items-center gap-2 mb-2'><img src={icons.Baggage} alt='Yes' width={18} /> Baggage</h4>
                        <ul className='ps-4'>
                            <li className='d-flex align-items-center gap-2'>
                                {data.cabinBaggage ? (
                                    <>
                                        <img src={icons.Check} alt='Yes' width={14} />
                                        {data.cabinBaggage} Cabin Baggage
                                    </>
                                ) : (
                                    <>
                                        <img src={icons.Times} alt='No' width={14} />
                                        No Cabin Baggage
                                    </>
                                )}
                            </li>
                            <li className='d-flex align-items-center gap-2'>
                                {data.baggage ? (
                                    <>
                                        <img src={icons.Check} alt='Yes' width={14} />
                                        {data.baggage} Check-in Baggage
                                    </>
                                ) : (
                                    <>
                                        <img src={icons.Times} alt='No' width={14} />
                                        No Check-in Baggage
                                    </>
                                )}
                            </li>
                        </ul>
                    </div>
                    <div className="mb-3">
                        <h4 className='d-flex align-items-center gap-2 mb-2'><img src={icons.Calendar} alt='Yes' width={18} /> Flexibility</h4>
                        <ul className='ps-4'>

                            <li className='d-flex align-items-center gap-2'>
                                {data.refund_type ? (
                                    <>
                                        <img src={icons.Check} alt='Yes' width={14} />
                                        {data.refund_type}
                                    </>
                                ) : (
                                    <>
                                        <img src={icons.Times} alt='No' width={14} />
                                        No refund on Cancellation
                                    </>
                                )}
                            </li>

                        </ul>
                    </div>

                    <div className="">
                        <h4 className='d-flex align-items-center gap-2 mb-2'><img src={icons.Meal} alt='Yes' width={18} /> Addons</h4>
                        <ul className='ps-4'>

                            <li className='d-flex align-items-center gap-2'>
                                {data.meal ? (
                                    <>
                                        <img src={icons.Check} alt='Yes' width={14} />
                                        {data?.meal}
                                    </>
                                ) : (
                                    <>
                                        <img src={icons.Times} alt='No' width={14} />
                                        Meals information not available
                                    </>
                                )}
                            </li>

                        </ul>
                    </div>

                    <div className=''>

                        {data.coupon_discount && (
                            <>
                                <h5 className='mt-3 bg-light-success px-2 py-2 rounded text-success text-center'>
                                    {data.coupon_discount}
                                </h5>
                            </>
                        )}
                    </div>


                </div>
            </div>
        </Card>
    );
};

export default FlightRoundTripFareCard;
